import { FunctionComponent } from 'react';

import Autocomplete from '@Components/Autocomplete';

import SelectProps from './Select.types';

const Select: FunctionComponent<SelectProps> = (props: SelectProps) => (
  <Autocomplete select {...props} />
);

Select.defaultProps = {
  variant: 'primary',
};

export default Select;
